import { useMemo } from 'react';

import { useEnv } from '@/src/application/hooks/util/useEnv';
import configData from '@/src/config.json';
import { APIService } from '@/src/infrastructure/Protocol/APIService';

import { ApiManagerService } from './ApiManagerService';
import { StubApiManagerService } from './StubApiManagerService';

export const useApiManagerService = () => {
  const { env } = useEnv();

  const service = useMemo(() => {
    if (env !== 'storybook') {
      const { JWT_DEV_TOKEN } = configData.endpoints[env];
      const jwt =
        JWT_DEV_TOKEN !== ''
          ? JWT_DEV_TOKEN
          : (window as Window & typeof globalThis & { __JWTToken: string }).__JWTToken;

      //FIXME: This is a temporary URL (magic string) and should be replaced with a monorepo services
      return ApiManagerService.create(new APIService('https://apiqa.embluemail.com/v2.2', jwt));
    } else {
      return StubApiManagerService.create();
    }
  }, [env]);

  return service;
};
